import { AGGREGATOR_BASE_URL } from 'src/environments/base-url';

export const gamesBulkUploadUrl = (): string => `${AGGREGATOR_BASE_URL}/games/bulk`;
